import { render, staticRenderFns } from "./Farmers.vue?vue&type=template&id=51f9293a&scoped=true"
import script from "./Farmers.vue?vue&type=script&lang=js"
export * from "./Farmers.vue?vue&type=script&lang=js"
import style0 from "./Farmers.vue?vue&type=style&index=0&id=51f9293a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f9293a",
  null
  
)

export default component.exports